import s from "./vision.module.css"
import { BsTwitter } from "react-icons/bs"
import { IconContext } from "react-icons";
import { useState } from "react";

export default function Vision({colorFondo}) {
    const [hover, setHover] = useState(true)
    const handleHoverin = ()=>{
        setHover(false)
    }
    const handleHoverout = ()=>{
        setHover(true)
    }
    return (
        <section className={s.section}>
            <div className={s.container}>
            <div className={s.visionContainer}><span className={s.vision}>vision</span></div>
            <div className={s.parrafContainer}>
                <span className={s.parraf}>Venom Soldiers is a collection of courageous eagles with the most loyal community. Our goal is to invade all Venom NFT projects and show the world our art. Join this army and share the vision</span>
            </div>
            {/* https://twitter.com/intent/tweet?text=How%20To%20Create%20Pre-written%20Tweets%3A&url=http%3A%2F%2Fow.ly/a3PIk%2F&via=hatchsteph&original_referer=https://socialmediahub.mit.edu/blog/how-create-pre-written-tweets */}
            {/* <div className={s[colorFondo]} onClick={()=>window.open("https://twitter.com/CantoZombs")} onMouseOver={()=>handleHoverin()} onMouseLeave={()=>handleHoverout()}> */}
            <div className={s[colorFondo]} onClick={()=>window.open("https://twitter.com/intent/tweet?text=@Venom_Soldiers%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20INVADE%20🪖%20WIN%20🧑‍🎖️%20")} onMouseOver={()=>handleHoverin()} onMouseLeave={()=>handleHoverout()}>

                <IconContext.Provider value={{ className: "global-class-name", size: "2.5em" }}>
                    <div><BsTwitter /></div>
                    <span className={s.share}>{hover ? "share the vision" : "Join the army"}</span>
                </IconContext.Provider>
            </div>
            </div>
        </section>
    )
}